import React from 'react';
import styled from 'styled-components';

import Icon from 'components/Icon';
import Pagination from 'components/Pagination';
import ShowMoreButton from 'components/ShowMoreButton';
import { I18n } from 'react-redux-i18n';

const isMobile = window.innerWidth <= 1200;

const CarouselContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 0 4px 4px 0;
  position: relative;
  z-index: 0;
  justify-content: center;

  @media (max-width: 1200px) {
    border-radius: 4px;
  }

  .title {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-top: 21px;
    margin-bottom: 4px;
    line-height: 20px;
    font-size: 12px;
    margin-left: 40px;
    text-transform: uppercase;

    > p {
      font-family: ${(props) => props.theme.fonts.oswald} !important;
    }
  }

  .iconContainer {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: rgba(31, 43, 55, 0.2);
    color: ${(props) => props.theme.colors['dark']};
    margin-right: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .innerCarouselContainer {
    width: 100%;
    display: grid;
    flex-direction: row;
    justify-content: space-between;
    grid-template-columns: 1fr 1fr 1fr;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};

    > p {
      font-size: 12px;
      font-family: ${(props) => props.theme.fonts.sfcompact_text};
    }

    > div {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    @media (max-width: 845px) {
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      grid-template-columns: 1fr;
      gap: 10px;
    }
  }

  .separator {
    @media (max-width: 900px) {
      display: none;
    }

    @media (max-width: 1500px) {
      margin-left: 1vw;
      margin-right: 1vw;
    }
  }

  .itemContainer {
    height: 70px;
  }

  .arrowContainer {
    @media (max-width: 1500px) {
      width: 30px !important;
      height: 30px !important;
    }
  }

  .surveyText {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 16px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    color: #2b3d54;
  }

  .surveyDate {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 14px;
    color: ${(props) => props.theme.colors['terra-cotta']};
  }

  .backContainer {
    width: 50px;
    height: 50px;
    background-color: ${(props) => props.theme.colors['white-three']};
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px;
  gap: 20px;
  height: 70px;

  @media (max-width: 900px) {
    flex-direction: column;
    justify-content: center;
    font-size: 12px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    height: auto;
    padding: 16px;
    gap: 16px;
  }
`;

const ItemContainer = styled.div``;

class Carousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startIndex: 0,
      endIndex: props.length ? props.length - 1 : 2
    };
  }

  renderButtonShowMore() {
    const { data } = this.props;
    if (data.length <= 3) {
      return null;
    }

    if (this.state.endIndex === data.length) {
      // show less
      return (
        <ShowMoreButton
          label={`${I18n.t('travel.seeLess')} (3)`}
          onClick={() => this.setState({ endIndex: 2 })}
        />
      );
    }

    return (
      <ShowMoreButton
        label={`${I18n.t('travel.seeMoreTable')} (+${data.length - 3})`}
        onClick={() => this.setState({ endIndex: data.length })}
      />
    );
  }

  render() {
    const {
      data,
      ItemComponent,
      title,
      icon,
      length = 3,
      noMargeLeft
    } = this.props;
    const { startIndex, endIndex } = this.state;
    return (
      <CarouselContainer noMargeLeft={noMargeLeft}>
        {title && (
          <div>
            <div className="title">
              <div className="iconContainer">
                <Icon icon={icon} />
              </div>

              <p>{title}</p>
            </div>
          </div>
        )}
        <Container>
          <div className="innerCarouselContainer">
            {data &&
              data.length > 0 &&
              data.slice(startIndex, endIndex + 1).map((itemData, index) => (
                <ItemContainer
                  className="itemContainer"
                  key={`itemCarousel-${index}`}
                >
                  <ItemComponent {...itemData} />
                </ItemContainer>
              ))}
          </div>
          {!isMobile ? (
            <div className="pagination">
              <Pagination
                disableLeft={startIndex === 0}
                disableRight={
                  endIndex > data.length - (length - 1) ||
                  data.length === length
                }
                onClickLeft={() =>
                  this.setState({
                    startIndex: this.state.startIndex - 1,
                    endIndex: this.state.endIndex - 1
                  })
                }
                onClickRight={() =>
                  this.setState({
                    startIndex: this.state.startIndex + 1,
                    endIndex: this.state.endIndex + 1
                  })
                }
              />
            </div>
          ) : (
            <>{this.renderButtonShowMore()}</>
          )}
        </Container>
      </CarouselContainer>
    );
  }
}

export default Carousel;
